// No Need to prepend BASE_URL as it is already configured with axios in src/api/api.ts
export const API_URLS = {
  USERS_LIST: "/partner/openfirepartners/",
  CHAT_LIST: "/management/chat-list/",
  INTERNAL_MESSAGE: "/management/internal-messages/",
  WAREHOUSE: "/management/warehouse/",
  DASHBOARD_ANALYTICS: "/management/dashboard-analytics/",
  SPARE_TRACK: "/management/spares-track/",
  SPARE_TRACK_DETAIL: "/management/get-track-detail/",
  PRODUCT_TRACK: "/management/product-tracking/",
  PRODUCT_MOVEMENT_HISTORY: "/management/get-product-movement/",
  SPARE_RETURN: "/management/return-spare/",
  DOA_SPARES: "/management/spares-doa/",
  VENDOR_DATA_RESPONSE: "/partner/vendor-data-response/",
  VENDOR_DATA_APPROVE: "/partner/vendor-data-approve/",
  ENGINEER_DELETE: "/partner/partner-remove-request/",
  SOW_SUBTYPE_ACTIONS: "/management/get-sowsubtype-action/",
  ADD_NEW_SOW_SUBTYPE_ACTION: "/management/add-sowsubtype-action/",
  VENDOR_PAST_INTERACTIONS: "/partner/vendor-interaction/",
  PINCODE_PARTNERS: "/management/assign-pin-partner/",
  CLOSE_TASK: "/management/close-tasks/",
  // Finance API endpoints
  PROJECTS_LIST: "/management/projects/",
  PAYMENT_PARTNERS: "/finance/invoicerequest_partner-list/",
  WORK_ORDERS: "/management/invoiceing_work-orders/",
  INVOICE_REQUEST: "/finance/invoice-request/",
  GENERATE_PARTNER_INVOICE: "/finance/generate-partner-invoice/",
  RESEND_PARTNER_INVOICE: "/finance/partner-invoice/resend/",
  RETRY_PARTNER_INVOICE: "/finance/partner-invoice/retry-create/",
};
